export const TWO_FACTOR_CHALLENGE_TOKEN_KEY = 'twoFactorChallengeToken'

export function storeTwoFactorChallengeToken(token: string | null | undefined) {
  if (token) {
    localStorage.setItem(TWO_FACTOR_CHALLENGE_TOKEN_KEY, token)
  } else {
    localStorage.removeItem(TWO_FACTOR_CHALLENGE_TOKEN_KEY)
  }
}

export function readTwoFactorChallengeToken(): string | null {
  return localStorage.getItem(TWO_FACTOR_CHALLENGE_TOKEN_KEY)
}

export function clearTwoFactorChallengeToken() {
  localStorage.removeItem(TWO_FACTOR_CHALLENGE_TOKEN_KEY)
}
